/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateOrderpickerTargetDto } from '../../models/create-orderpicker-target-dto';
import { OrderpickerTarget } from '../../models/orderpicker-target';

export interface CreateOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Params {
  orderpickerId: number;
      body: CreateOrderpickerTargetDto
}

export function createOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget(http: HttpClient, rootUrl: string, params: CreateOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderpickerTarget>> {
  const rb = new RequestBuilder(rootUrl, createOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget.PATH, 'post');
  if (params) {
    rb.path('orderpickerId', params.orderpickerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrderpickerTarget>;
    })
  );
}

createOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget.PATH = '/api/mgmt/orderpicker/{orderpickerId}/targets';
